import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statusFieldName: {
		id: 'project-settings-apps-issue-type-page-product-features.common.status-field.status-field-name',
		defaultMessage: 'Status',
		description: 'Label for status field',
	},
	required: {
		id: 'project-settings-apps-issue-type-page-product-features.common.status-field.required',
		defaultMessage: 'Required',
		description: 'Label for required status field',
	},
});
